// Formateadores locales de la vista de compras. No hay helper compartido en el
// proyecto (cada vista formatea a mano), así que se centralizan aquí para que
// tabla, ficha, modales y toasts pinten importes y fechas igual.

export const formatMoney = (amount: number, currency = 'EUR'): string =>
  `${amount.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;

export const formatQuantity = (quantity: number): string =>
  quantity.toLocaleString('es-ES', { maximumFractionDigits: 2 });

// Fechas DATE del backend ("2026-10-15") y timestamptz ("2026-09-10T11:16:22+00:00").
export const formatDate = (value: string | null | undefined): string => {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleDateString('es-ES');
};

export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return `${d.toLocaleDateString('es-ES')} ${d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}`;
};

// El backend rechaza "" en numéricos y buildQuery omite undefined: se parsea
// aquí una sola vez para que los inputs puedan quedarse vacíos mientras se escribe.
export const parseNumber = (value: string | number, fallback = 0): number => {
  if (typeof value === 'number') return isNaN(value) ? fallback : value;
  const n = parseFloat(String(value).replace(',', '.'));
  return isNaN(n) ? fallback : n;
};
